<template>
  <v-navigation-drawer
    v-model="showDrawer"
    dark
    fixed
    app
    class="app-navigation"
  >
    <v-list>
      <v-list-item to="dashboard">
        <v-list-item-icon>
          <v-icon>$dashboard</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t("dashboard") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <template v-if="currentHotel">
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          :to="item.to ? item.to : null"
          :href="item.url ? item.url : null"
          :target="item.url ? '_blank' : null"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t(item.titleKey) }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import permissions from "@/mixins/permissions";
export default {
  name: "AppNavigation",
  mixins: [permissions],
  props: {
    drawer: {
      type: Boolean,
      required: true,
    },
  },

  data: () => ({
    showDrawer: null,
  }),
  computed: {
    menuItems() {
      let menuItems = [
        {
          to: "payments",
          titleKey: "payments",
          icon: "$payments",
          visible: true,
        },
        {
          to: "reports",
          titleKey: "reports",
          icon: "$report",
          visible: this.userHasAdminRights || this.user.accessType === 11,
        },
        {
          to: "emailtemplates",
          titleKey: "emailTemplates",
          icon: "$email",
          visible: this.user.accessType !== 11,
        },
        {
          to: "accounts",
          titleKey: "accounts",
          icon: "$accounts",
          visible: this.user.accessType !== 11,
        },
        {
          url:
            this.language.id === 1
              ? "https://helpguide.smarthotel.nl/nl/smart-payments"
              : "https://helpguide.smarthotel.nl/en/smart-payments",
          titleKey: "help",
          icon: "$help",
        },
      ];
      return menuItems.filter((item) => item.visible);
    },
    showDashboard() {
      return [3, 4, 5, 6, 10].includes(this.user.accessType);
    },
    ...mapState(["user", "currentHotel"]),
    ...mapState("language", ["language"]),
  },
  watch: {
    showDrawer(newValue) {
      this.$emit("update:drawer", newValue);
    },
    drawer(val) {
      this.showDrawer = val;
    },
  },
};
</script>
